export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    resultsTitle: {
      type: String,
      required: true,
    },
    searchPlaceholder: {
      type: String,
      required: true,
    },
    emptyPositionsText: {
      type: String,
    },
    gtm: {
      type: Object,
    },
  },

  computed: {
    queryString() {
      return this.$route.query.search
    },
  },

  methods: {
    clearSearch() {
      this.$router.push({ name: `positions___${this.$i18n.locale}` })
    },
  },
}
